<template>
	<div>
		<div class="row">
			<div class="col-12">
				<InputText id="name" name="name" :form="values" :errors="errors" maxLength="50"/>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-right">
				<button class="button-action" @click="save">{{ newLocation ? 'Add Location' : 'Save Changes' }}</button>
			</div>
		</div>
	</div>
</template>

<script>
import InputText from '../Form/InputText.vue'

export default {
	components: {
		InputText
	},
	props: [
		'location',
	],
	data() {
		return {
			values: {},
			errors: {},
			requiredFields: ['name'],
			newLocation: true
		}
	},
	methods: {
		formIsValid() {
			let validForm = true

			this.errors = {}

			this.requiredFields.forEach(field => {
				if(!this.values.hasOwnProperty(field) || this.values[field] == '') {
					this.errors[field] = 'This field is required.'
					validForm = false
				}
			})

			return validForm
		},
		save() {
			if(!this.formIsValid()) {
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'Form error - please check and re-submit',
					timeout: 3000
				})
				return
			}

			const action = this.newLocation ? 'create' : 'update'
			const postActionDescription = this.newLocation ? 'Added' : 'Updated'

			this.$store.commit('app/setLoading', true)
			this.$store.dispatch(`locations/${action}`, this.values)
			.then(() => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: `Item ${postActionDescription}`,
					timeout: 3000
				})
				this.$emit('close');
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false)
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	},
	mounted() {
		if(this.location) {
			this.values = JSON.parse(JSON.stringify(this.location))
			this.newLocation = false
		}
	}
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Locations/Form.vue